import { IScreen9 } from 'source/NFR.types';

interface Screen9Props extends IScreen9 {
  title?: string;
}

const Screen9: React.FC<Screen9Props> = ({ embed, title }) => {
  if (!embed) return null;
  return (
    <div className="screen9-video-container">
      <iframe
        allow="autoplay; fullscreen"
        allowFullScreen
        referrerPolicy="no-referrer-when-downgrade"
        src={embed}
        loading="eager"
        className="screen9-video-iframe"
        title={title}
      />
    </div>
  );
};

Screen9.displayName = 'Screen9';

export default Screen9;
